import React from "react";
import { Table, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { TransferItem } from "../../../Types";

interface Props {
  items: TransferItem[];
  onRemove: (stockId: string) => void;
}

export const TransferItemsList: React.FC<Props> = ({ items, onRemove }) => {
  const columns = [
    {
      title: "Item",
      key: "details",
      render: (_: any, r: TransferItem) => (
        <div>
          <span className="font-medium text-xs text-gray-800">
            {r.product_title}
          </span>
          <span className="ml-1 text-[11px] text-gray-400">({r.sku_code})</span>
        </div>
      ),
    },
    {
      title: "Batch",
      dataIndex: "batch_no",
      render: (val: string) => (
        <span className="text-xs text-gray-600">{val}</span>
      ),
    },
    {
      title: "Qty",
      dataIndex: "quantity",
      align: "right" as const,
      render: (val: number, r: TransferItem) => (
        <span className="font-semibold text-xs text-gray-700">
          {val} {r.unit}
        </span>
      ),
    },
    {
      key: "action",
      width: 48,
      align: "center" as const,
      render: (_: any, r: TransferItem) => (
        <Button
          icon={<DeleteOutlined />}
          type="text"
          danger
          size="small"
          onClick={() => onRemove(r.stock_id)}
        />
      ),
    },
  ];

  return (
    <div>
      <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
        Items ({items.length})
      </div>
      <Table
        dataSource={items}
        rowKey="stock_id"
        size="small"
        pagination={false}
        columns={columns}
        locale={{ emptyText: "No items added yet." }}
        className="rounded-md border border-gray-100 overflow-hidden"
      />
    </div>
  );
};
